module.exports = __webpack_public_path__ + "media/images/svgs/realestate/cabin-f972e548ccb9bceb338c644070cfef42.svg";